import axios, { AxiosResponse } from 'axios';
import qs from 'qs';

import commonUtil from '@/shared/lib/common';
import url from '../lib/url';
import { useLoginStore } from '@/shared/lib/store/model/login.store';
import { usePersistStore } from '@/shared/lib/store';
import { waitForToken } from '../utils/wait-for-token';

export const getUseLoginStore = () => {
    const loginState = useLoginStore.getState();
    return loginState;
};

export const getPersistStore = () => {
    const persistState = usePersistStore.getState();
    return persistState;
};

export const ApiUtil = {
    // API.Response.resultData 반환
    get: async <Res>(endpoint: string, data: any, isLoading?: boolean): Promise<Res | undefined> =>
        request<Res>('vcloudapi', 'get', endpoint, data, isLoading),
    post: async <Res>(endpoint: string, data: any, isLoading?: boolean): Promise<Res | undefined> =>
        request<Res>('vcloudapi', 'post', endpoint, data, isLoading),
    lcms_get: async <Res>(
        endpoint: string,
        data: any,
        isLoading?: boolean
    ): Promise<Res | undefined> => request<Res>('lcmsapi', 'get', endpoint, data, isLoading),
    lcms_post: async <Res>(
        endpoint: string,
        data: any,
        isLoading?: boolean
    ): Promise<Res | undefined> => request<Res>('lcmsapi', 'post', endpoint, data, isLoading),
    // put: async <Res>(endpoint: string, data: any, isLoading?: boolean): Promise<Res | undefined> => request<Res>('vcloudapi', "put", endpoint, data, isLoading),
    // delete: async <Res>(endpoint: string, data: any, isLoading?: boolean): Promise<Res | undefined> => request<Res>('vcloudapi', "delete", endpoint, data, isLoading),

    // API.Response 반환
    _get: async <Res>(
        endpoint: string,
        data: any,
        isLoading?: boolean
    ): Promise<API.Response<Res> | undefined> =>
        _request<Res>('vcloudapi', 'get', endpoint, data, isLoading),
    _post: async <Res>(
        endpoint: string,
        data: any,
        isLoading?: boolean
    ): Promise<API.Response<Res> | undefined> =>
        _request<Res>('vcloudapi', 'post', endpoint, data, isLoading),
    // _put: async <Res>(endpoint: string, data: any, isLoading?: boolean): Promise<API.Response<Res> | undefined> => _request<Res>('vcloudapi', "put", endpoint, data, isLoading),
    // _delete: async <Res>(endpoint: string, data: any, isLoading?: boolean): Promise<API.Response<Res> | undefined> => _request<Res>('vcloudapi', "delete", endpoint, data, isLoading),

    __get: async <Res>(
        endpoint: string,
        data: any,
        isLoading?: boolean
    ): Promise<Res | undefined> =>
        axios_request<Res>('vcloudapi', 'get', endpoint, data, isLoading),
    viva_get: async <Res>(
        endpoint: string,
        data: any,
        isLoading?: boolean
    ): Promise<Res | undefined> => axios_request<Res>('viva', 'get', endpoint, data, isLoading),
    multipart: async <Res>(
        endpoint: string,
        data: any,
        isLoading?: boolean
    ): Promise<Promise<Res | undefined>> =>
        axios_request<Res>('vcloudapi', 'multipart', endpoint, data, isLoading),

    uUrl: (url: string): string => {
        const typeCode = getUseLoginStore()?.memberInfo.typeCode;

        return (typeCode === '0' || typeCode === '1' || typeCode === '2' ? '/tch' : '/stnt') + url;
    },
    test_get: async <Res>(
        endpoint: string,
        data: any,
        isLoading?: boolean
    ): Promise<Res | undefined> =>
        request<Res>('test-aidt-domain', 'get', endpoint, data, isLoading),
    test_post: async <Res>(
        endpoint: string,
        data: any,
        isLoading?: boolean
    ): Promise<Res | undefined> =>
        request<Res>('test-aidt-domain', 'post', endpoint, data, isLoading),
};

type ApiServerType =
    | 'vcloudapi'
    | 'lcmsapi'
    | 'medianaviapi'
    | 'tutorus'
    | 'keris'
    | 'viva'
    | 'test-aidt-domain';
type MethodType = 'get' | 'put' | 'post' | 'delete' | 'multipart';
const request = async <Res>(
    apiServer: ApiServerType,
    method: MethodType,
    endpoint: string,
    data: any,
    isLoading?: boolean
): Promise<Res | undefined> => {
    // API.Response.resultData 반환
    const res = await _request<Res>(apiServer, method, endpoint, data, isLoading);
    return res && res.success ? res.resultData : undefined;
};
const _request = async <Res>(
    apiServer: ApiServerType,
    method: MethodType,
    endpoint: string,
    data: any,
    isLoading?: boolean
): Promise<API.Response<Res> | undefined> => {
    // API.Response 반환
    const res = await axios_request<API.Response<Res>>(
        apiServer,
        method,
        endpoint,
        data,
        isLoading
    );
    if (res && res.currentTime) {
        usePersistStore?.getState().setSCurrentTime(res.currentTime);
    }
    return res ? (res as API.Response<Res>) : undefined;
};

const axios_request = async <Res>(
    apiServer: ApiServerType,
    method: MethodType,
    endpoint: string,
    data: any,
    isLoading?: boolean
): Promise<Res | undefined> => {
    // AxiosResponse.data 반환
    const res = await _axios_request<Res>(apiServer, method, endpoint, data, isLoading);
    return res ? (res.data as Res) : undefined;
};

const _axios_request = async <Res>(
    apiServer: ApiServerType,
    method: MethodType,
    endpoint: string,
    data: any,
    isLoading: boolean = true
): Promise<AxiosResponse<Res> | undefined> => {
    // AxiosResponse 반환
    const getBaseUrl = () => {
        switch (apiServer) {
            default:
            case 'vcloudapi':
                return url.vCloudApi();
            case 'lcmsapi':
                return url.lCmsApi();
            case 'medianaviapi':
                return url.medianaviApi();
            case 'tutorus':
                return import.meta.env.VITE_AIDT_URL_TUTOR_CHATBOT_API;
            // case 'keris':
            //     return url.kerisApi();
            case 'viva':
                return url.vivaApi();
            case 'test-aidt-domain':
                return import.meta.env.VITE_AIDT_URL_TEST_LMSAPI_VIEWER;
        }
    };
    const token = sessionStorage.getItem('persist-token');
    const parsedToken = JSON.parse(token!);
    const sToken = parsedToken?.state?.sToken;
    const sHmac = parsedToken?.state?.sHmac;
    const baseURL = getBaseUrl();
    if (apiServer === 'keris') {
        data['access_token'] = {
            token: sToken,
            access_id: getUseLoginStore()?.loginInfo?.memberId,
        };
    }

    const headers: any = {
        'Content-Type': method == 'multipart' ? 'multipart/form-data' : 'application/json',
        accept: 'application/json',
        // 'Partner-ID': getUserState().sPartnerId,
    };
    if (apiServer == 'vcloudapi' || apiServer == 'lcmsapi') {
        // const timestamp = Date.now();
        // const timestamp = 1;
        // const response = await fetch(baseURL + `/common/jwt?timestamp=${timestamp}&id=${persist.sAccessId}`);
        // if (response) {
        //     const jwtData = await response.json();
        //     headers['Authorization'] = `Bearer ${jwtData.jwtToken}`;
        //     headers['HMAC'] = jwtData.hmac;
        // }
        // headers['Authorization'] = `Bearer ${getUserState().sInnerAccessToken}`;

        headers['HMAC-id'] = getUseLoginStore()?.loginInfo?.memberId;
        headers['HMAC'] = sHmac;
        headers['X-App-Name'] = 'sbank';
    } else if (apiServer == 'tutorus') {
        const apis = ['/api/esearch', '/api/instructgen'];
        if (apis.includes(endpoint)) {
            headers['Authorization'] = `Bearer ${sToken}`;
            headers['HMAC-id'] = getUseLoginStore()?.loginInfo?.memberId;
            headers['HMAC'] = sHmac;
        }
    }

    // TODO Unauthorization
    // const token = store.persist.sToken;
    // if (token === undefined) {
    // }

    const instance = axios.create({
        baseURL,
        headers,
        paramsSerializer: {
            encode: (val) => {
                return encodeURIComponent(val)
                    .replace(/%40/gi, '@')
                    .replace(/%3A/gi, ':')
                    .replace(/%24/g, '$')
                    .replace(/%2C/gi, ',')
                    .replace(/%20/g, '+')
                    .replace(/%5B/gi, '[')
                    .replace(/%5D/gi, ']');
            },
            serialize: (params) => {
                return qs.stringify(params, { arrayFormat: 'brackets' });
            },
        },
    });
    // store.main.common.loading = isLoading;
    let axiosResponse: AxiosResponse<Res>;

    instance.interceptors.request.use(
        async (config) => {
            if (apiServer == 'vcloudapi' || apiServer == 'lcmsapi') {
                try {
                    if (
                        config?.url?.includes('common/jwt') ||
                        config?.url?.includes('session/jwt') ||
                        config?.url?.includes('common/dateTime')
                    ) {
                        return config;
                    }
                    const sToken = await waitForToken();

                    if (sToken) config.headers.Authorization = `Bearer ${sToken}`;
                } catch (error) {
                    console.error('요청 에러:', error);
                }
                // const { sToken } = usePersistStore.getState();
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    instance.interceptors.response.use(
        (response) => response,

        async (error) => {
            const originalRequest = error.config;
            if (
                (error.response.status === 401 ||
                    error.response?.data?.message?.includes('JWT 만료')) &&
                !originalRequest._retry
            ) {
                originalRequest._retry = true;
                const { refreshAccessToken, setSIsLogout, sRefreshToken, setPersistToken } =
                    usePersistStore.getState();
                try {
                    if (sRefreshToken) {
                        const newAccessToken = await refreshAccessToken();
                        const getToken = (jwt: any) => {
                            return jwt?.accessToken;
                        };

                        if (!newAccessToken) {
                            setSIsLogout(); // 자동 로그아웃
                            throw new Error('토큰 갱신 실패');
                        } else {
                            setPersistToken(newAccessToken);
                            error.config.headers.Authorization = `Bearer ${getToken(newAccessToken)}`;
                            return instance(error.config); // ✅ 갱신 후 실패한 요청 재시도
                        }
                    }
                } catch (refreshError) {
                    console.error('토큰 갱신 실패:', refreshError);
                    setSIsLogout(); // 자동 로그아웃
                }
            }
            return Promise.reject(error);
        }
    );
    try {
        switch (method) {
            case 'get':
                axiosResponse = await instance.get<Res>(endpoint, { params: data });
                break;
            case 'post':
            case 'multipart':
                axiosResponse = await instance.post<Res>(endpoint, data);
                break;
            case 'put':
                axiosResponse = await instance.put<Res>(endpoint, data);
                break;
            case 'delete':
                axiosResponse = await instance.delete<Res>(endpoint, { params: data });
                break;
        }
        commonUtil.log('[NAVI] api response', baseURL, endpoint, axiosResponse);
        return axiosResponse;
    } catch (e) {
        commonUtil.log('[NAVI] api response exception', e);
        // throw new Error('API Error');
    } finally {
        // store.main.common.loading = false;
    }
};

export const DefaultPageInfo: API.PageInfo = {
    number: 0,
    totalPages: 0,
    totalElements: 0,
    size: 10,
};

export const LcmsApiUtil = {
    get: async <Res>(endpoint: string, data: any): Promise<Res | undefined> =>
        axios_request<Res>('lcmsapi', 'get', endpoint, data),
    post: async <Res>(endpoint: string, data: any): Promise<Res | undefined> =>
        axios_request<Res>('lcmsapi', 'post', endpoint, data),
    put: async <Res>(endpoint: string, data: any): Promise<Res | undefined> =>
        axios_request<Res>('lcmsapi', 'put', endpoint, data),
    delete: async <Res>(endpoint: string, data: any): Promise<Res | undefined> =>
        axios_request<Res>('lcmsapi', 'delete', endpoint, data),
};

export const MediaNaviApiUtil = {
    get: async <Res>(endpoint: string, data: any): Promise<Res | undefined> =>
        axios_request<Res>('medianaviapi', 'get', endpoint, data),
    post: async <Res>(endpoint: string, data: any): Promise<Res | undefined> =>
        axios_request<Res>('medianaviapi', 'post', endpoint, data),
    put: async <Res>(endpoint: string, data: any): Promise<Res | undefined> =>
        axios_request<Res>('medianaviapi', 'put', endpoint, data),
    delete: async <Res>(endpoint: string, data: any): Promise<Res | undefined> =>
        axios_request<Res>('medianaviapi', 'delete', endpoint, data),
};

export const TutorusApiUtil = {
    get: async <Res>(endpoint: string, data: any): Promise<Res | undefined> =>
        axios_request<Res>('tutorus', 'get', endpoint, data),
    post: async <Res>(endpoint: string, data: any): Promise<Res | undefined> =>
        axios_request<Res>('tutorus', 'post', endpoint, data),
    put: async <Res>(endpoint: string, data: any): Promise<Res | undefined> =>
        axios_request<Res>('tutorus', 'put', endpoint, data),
    delete: async <Res>(endpoint: string, data: any): Promise<Res | undefined> =>
        axios_request<Res>('tutorus', 'delete', endpoint, data),
};

export const KerisApiUtil = {
    get: async <Res>(endpoint: string, data: any): Promise<Res | undefined> =>
        axios_request<Res>('keris', 'get', endpoint, data),
    post: async <Res>(endpoint: string, data: any): Promise<Res | undefined> =>
        axios_request<Res>('keris', 'post', endpoint, data),
    put: async <Res>(endpoint: string, data: any): Promise<Res | undefined> =>
        axios_request<Res>('keris', 'put', endpoint, data),
    delete: async <Res>(endpoint: string, data: any): Promise<Res | undefined> =>
        axios_request<Res>('keris', 'delete', endpoint, data),
};

// export const KerisMockupApiUtil = {
//     get: async <Res>(endpoint: string, data: any): Promise<Res | undefined> => axios_request<Res>('vcloudapi', "get", endpoint, data),
//     post: async <Res>(endpoint: string, data: any): Promise<Res | undefined> => axios_request<Res>('vcloudapi', "post", endpoint, data),
//     put: async <Res>(endpoint: string, data: any): Promise<Res | undefined> => axios_request<Res>('vcloudapi', "put", endpoint, data),
//     delete: async <Res>(endpoint: string, data: any): Promise<Res | undefined> => axios_request<Res>('vcloudapi', "delete", endpoint, data),
// }
